import { trapFocus } from '../../../ts/helper';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="columns-tariffs"]';

/**
 * Friendation component
 */
export const columnsTariffs = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handlePopups = () => {
      const tariffs: HTMLElement[] = Array.from(
        component.querySelectorAll('.tariff')
      );
      let removeTrapFocus;

      tariffs.forEach((tariff) => {
        const specificationItems: HTMLLIElement[] = Array.from(
          tariff.querySelectorAll('.listItem')
        );

        specificationItems.forEach((specificationItem) => {
          const trigger: HTMLButtonElement =
            specificationItem.querySelector('.popupTrigger');
          if (!trigger) return;

          const closeButton: HTMLButtonElement =
            specificationItem.querySelector('.popupClose');
          const popup: HTMLElement = specificationItem.querySelector('.popup');

          const onClick = (e: MouseEvent) => {
            e.preventDefault();

            const isOpen = trigger.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
              close();
            } else {
              open();
            }
          };

          const onKeyDown = (e: KeyboardEvent) => {
            if (e.code === 'Escape') {
              close();
            }
          };

          const open = () => {
            trigger.setAttribute('aria-expanded', 'true');
            popup.inert = false;
            removeTrapFocus = trapFocus(popup); // focus is trapped
            popup.tabIndex = -1;
            setTimeout(() => {
              popup.focus();

              document.addEventListener('keydown', onKeyDown);
            }, 100);
          };

          const close = () => {
            trigger.setAttribute('aria-expanded', 'false');
            popup.inert = true;
            if (removeTrapFocus) removeTrapFocus(); // focus is no longer trapped
            document.removeEventListener('keydown', onKeyDown);

            setTimeout(() => {
              trigger.focus();
            }, 100);
          };

          trigger.addEventListener('click', onClick);
          closeButton.addEventListener('click', close);
        });
      });
    };

    handlePopups();
  });
};
